import React, { useEffect } from 'react';
import { Box, Heading, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { useCurrentCategoryValue } from '../../../context/dropshippingContext';
import { useSetSelectedThemeColor, useColorThemeState } from '../context/templateContext';
import { THEME_KEYS } from '@common/constants/themes';
import { TemplateGrid } from '../components/TemplateGrid/TemplateGrid';

export function TemplateSelection() {
  const { t } = useTranslation();
  const selectedCategory = useCurrentCategoryValue();
  const setSelectedThemeColor = useSetSelectedThemeColor();
  const [{ selectedThemeColor }] = useColorThemeState();

  useEffect(() => {
    if (!selectedThemeColor) {
      setSelectedThemeColor(THEME_KEYS.RECOMMENDED);
    }
  }, [selectedThemeColor, setSelectedThemeColor]);

  if (!selectedCategory) {
    return null;
  }

  return (
    <Box direction="vertical" height="100%" width="100%" gap={2}>
      <Box direction="vertical" height="100%" gap={3}>
        <Box direction="vertical" gap={1}>
          <Heading size="medium">{t('template_select.header.title')}</Heading>

          <Text>{t('template_select.header.subtitle')}</Text>
        </Box>

        <TemplateGrid />
      </Box>
    </Box>
  );
}
